<template>
  <div class="proveedores-search-list search-list">
    <b-row class="search-list-filter">
      <b-col cols="12" xl="12">
        <b-form>
          <b-form-group
            label="Nombre Comercial / Razón Social:"
            label-for="nombre"
            :label-cols="4"
            horizontal>
            <b-form-input 
              id="nombre" 
              v-model="nombre" 
              type="text">
            </b-form-input>
          </b-form-group>
        </b-form>
      </b-col>      
    </b-row>

    <b-row class="search-list-table">
      <b-col cols="12" xl="12">  
        <b-table hover  
            responsive="sm" 
            class="registro"
            :busy="tableBusy"
            :items="proveedores" 
            :fields="proveedorFields"
            :filter="nombre"
            :current-page="paginaActual"
            :per-page="registrosPorPagina"
            @filtered="onFiltered"
            @row-clicked="seleccionarProveedor">
          <div slot="table-busy" class="text-center">
            <b-spinner class="table-spinner" label="Spinning" />
          </div>              
        </b-table>
      </b-col>
    </b-row>
    <b-row class="search-list-pagination">
      <b-col cols="12" xl="12">  
        <nav>
          <b-pagination size="sm" 
            :total-rows="totalRegistros" 
            :per-page="registrosPorPagina" 
            v-model="paginaActual" 
            prev-text="Prev." next-text="Prox."/>
        </nav>
      </b-col>
    </b-row>
  </div>
</template>

<script>

export default {
  name: 'Proveedores',
  props: {
    transportes: {
      type: Boolean,
      default: false
    },
    incluirInactivos: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      proveedores: [],
      proveedorFields: [
        {
          key: 'id',
          label: 'Cód.'
        },
        {
          key: 'nombre',
          label: 'Proveedor',
          sortable: true
        },
        {
          key: 'razonSocial',
          label: 'Razón Social',
          sortable: true
        },
      ],

      loaded: false,
      tableBusy: false,
      /* Info de paginación */
      paginaActual: 1,
      totalPaginas: 1,
      registrosPorPagina: 5,
      totalRegistros: 0,

      nombre: null,
    }
  },
  computed: {
  },
  created() {
    this.getProveedores()
  },  
  methods: {
    getProveedores() {
      let params = {
        transportes: this.transportes,
        incluirInactivos: this.incluirInactivos,
        // impuestos: true
      }
      this.tableBusy = true;
      this.$store.dispatch('proveedores/getList', params)
        .then(() => {
          this.proveedores = this.$store.getters['proveedores/list'];
          this.totalRegistros = this.proveedores.length;
          this.tableBusy = false;
        })
    },
    seleccionarProveedor (item) {
      this.$emit('proveedorSeleccionado', item)
    },
    onFiltered(filteredItems) {
      this.totalRegistros = filteredItems.length
      this.paginaActual = 1
    }    
  },
}
</script>

<style>
  .proveedores-search-list .registro table td[aria-colindex="1"] {
    width: 10%;
  }
  .proveedores-search-list .registro table td[aria-colindex="2"],
  .proveedores-search-list .registro table td[aria-colindex="3"] {
    width: 45%;
  }
</style>
